export default "__VITE_IMAGE_ASSET__aa7fad13__";